/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import React from 'react';

import { IconName } from 'app/common/components/controls/icon';
import HeaderButton from './button';
import styles from './header.less';

const noop = () => {};

const classes = classNames(
  'paws-open-preferences',
  styles.desktopSettingsButton,
);

/**
 * This button has click handler binding in the desktop code via jQuery. Ugh.
 */
const DesktopSettingsButton: React.FunctionComponent = () => {
  return (
    <HeaderButton className={classes} icon={IconName.Gear} onClick={noop} />
  );
};

export default DesktopSettingsButton;
